/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION : CONFIG CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
    configv3controller: {
        minHeight: pxToEm(80),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: replacePXinStringWithEM('0 4px'),
        margin: replacePXinStringWithEM('0 24px'),
        borderBottom: '2px solid #fff',
        cursor: 'pointer',
        '&.opened-true': {
            borderBottom: '2px solid #aeb6d6',
            // cursor: props => props.hideDefaultActionButtons || props.actionButtons ? 'pointer' : 'default'
        },
        '& .header': {
            display: 'flex',
            alignItems: 'center',
            gap: pxToEm(16),
            '& .title': { fontSize: pxToEm(20) },
            '& [fill]:not(svg)': {
                fill: '#5566AA'
            }
        },
        '& .actions': {
            display: 'flex',
            gap: pxToEm(16),
            alignItems: 'center'
        },
        '& .actionbuttons': {
            display: 'flex',
            gap: pxToEm(12),
            opacity: 0,
            animationName: 'fadeInUp',
            animationDelay: '.1s',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            '& .button': {
                height: pxToEm(40)
            },
            '& .MuiButtonGroup-root': {
                    backgroundColor : '#061240 !important',

                '& > .MuiButton-sizeMedium': {
                    borderRight: '0.8px solid #505876 ',
                    color: '#FFF',
                    textAlign: 'center',
                    fontFamily: "Work Sans",
                    fontSize: pxToEm(14),
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: pxToEm(18),
                    textTransform : 'none !important',
                },
                '& > button': {
                    backgroundColor : '#061240 !important',
                    color : '#fff !important',
                },
                '& > .splitButtonToggle':{
                    backgroundColor : '#F2F4F8 !important',
                    boxShadow: 'none !important',
                },
                '& > button:disabled':{
                        pointerEvents: 'none',
                        backgroundColor : '#F2F4F8 !important',
                        color: '#DFDFDF !important'
                },
            },
            '& > .splitbuttondisabled' : {
                backgroundColor : '#F2F4F8 !important',
                boxShadow: 'none !important',
            },
            '& > .MuiPopper-root' : {
                transform: 'translate3d(36px, 40px, 0px) !important',
            }
        },
        '& .toggleicons': {
            display: 'flex',
            '& svg': {
                width: pxToEm(18),
                height: pxToEm(18),
                '&.toggle-up': {
                    cursor: 'pointer',
                    '& path': { fill: '#DFDFDF' }
                },
                '&.toggle-down': {
                    cursor: 'pointer',
                    '& path': { fill: '#DFDFDF' }
                }
            }
        },
        '&.disabled-true': {
            '& .title': {
                extend: disable
            }
        },
        [mediaQuery.customizeThinnest]: {
            flexDirection: 'column',
            '& > *': {
                marginTop: pxToEm(16)
            },
            '& > *:last-child': {
                marginBottom: pxToEm(16)
            }
        },
        '& .button:not(:first-child)': {
            marginLeft: pxToEm(16)
        },
        '& .description': {

        },
        '& .button': {
            height: pxToEm(32),
            width: 'auto',
            padding: replacePXinStringWithEM('0 16px'),
            '& .text': {
                fontSize: pxToEm(14),
                fontWeight: 500,
                fontFamily: '"Work Sans", sans-serif;'
            }
        }
    },
    '@global': {
        '.MuiPopper-root' : {
            marginTop: '5px !important',
            '& > .MuiPaper-root' : {
                display: 'flex',
                width: pxToEm(220),
                padding: '16px 0px',
                flexDirection: 'column',
                alignItems: 'flex-start',
                borderRadius: pxToEm(12),
                border: '1px solid #7E92B8',
                background: '#FFF',
                boxShadow: '0px 4px 10px 0px rgba(178, 193, 230, 0.30)',
                '& > ul' :{
                    width: '100%',
                    '& > li' : {
                        display: 'inline-flex',
                        height: pxToEm(32),
                        padding: '0px 16px',
                        alignItems: 'center',
                        gap: pxToEm(8),
                        alignSelf: 'stretch',
                        color: '#061240',
                        fontFamily: "Work Sans",
                        fontSize: pxToEm(14),
                        fontStyle: 'normal',
                        fontWeight: '500',
                        lineHeight: pxToEm(16),
                        width: '100%',
                    }
                },

            }
        },
        '.MuiButtonGroup-root':{
            borderRadius: '12px !important',
            background: '#061240',
            display: 'flex',
            alignItems: 'center'
        },
        '.MuiButton-sizeSmall': {
            borderRadius: '12px !important',
        }

    }

});
